import Request from "./Request";

export async function checkInputAvailability({
	input,
	value,
	apiUrl,
	payloadBuilder = (val) => val,
	validate,
	onInvalid,
	onExists,
	onApiError,
	onSuccess,
	onStart,
	onFinally,
}) {
	if (!input || !value) return;

	// Format validation
	if (validate && !validate(value)) {
		onInvalid?.();
		return;
	}

	// Ensure wrapper + loader only once
	let wrapper = input.closest('.input-with-loader');
	let loader;

	if (!wrapper) {
		wrapper = document.createElement('div');
		wrapper.classList.add('input-with-loader');
		input.parentNode.insertBefore(wrapper, input);
		wrapper.appendChild(input);

		loader = document.createElement('span');
		loader.className = 'lta-field-loader';
		wrapper.appendChild(loader);
	} else {
		loader = wrapper.querySelector('.lta-field-loader');
	}

	onStart?.();
	loader.style.display = 'inline-block';
	input.style.pointerEvents = 'none';

	try {
		const response = await Request.post(apiUrl, payloadBuilder(value));
		const { accountExists, statusCode } = response;

		if (accountExists) {
			onExists?.(response);
		} else if (!accountExists && statusCode === '99') {
			onApiError?.(response);
		} else {
			onSuccess?.(response);
		}
	} catch (err) {
		console.error('Availability check failed:', err);
		onApiError?.(err);
	} finally {
		loader.style.display = 'none';
		input.style.pointerEvents = '';
		onFinally?.();
	}
}
